import { render, staticRenderFns } from "./crudActivity.vue?vue&type=template&id=05af5383&"
import script from "./crudActivity.vue?vue&type=script&lang=js&"
export * from "./crudActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports